import { useTransition } from "react-spring";
import { developerData, designerData } from "./content/skills";
import { animated } from "react-spring";

const Skill = () => {
    const forward = ['//'];
    function developer(developerData) {
        return (
            <div className="logo_container">
                <a href={developerData.link}><img className="logo" id={developerData.id} src={developerData.logo} alt={developerData.name} /></a><br />
                {developerData.name}
            </div>
        );
    }
    function designer(designerData) {
        return (
            <div className="logo_container">
                <a href={designerData.link}><img className="logo" id={designerData.id} src={designerData.logo} alt={designerData.name} /></a><br />
                {designerData.name}
            </div>
        );
    }

    const transition = useTransition(1, {
        from: { y: 1000, opacity: 0 },
        enter: { y: 0, opacity: 1, delay: 200 },
        leave: {},
    });

    return (
        <div className="skills">

            {
                transition(
                    (style, items) =>
                        items ? <animated.div style={style}>
                            <h1>{forward}skills</h1>
                            <div className="skillgrps">
                                <div className="developer">
                                    <h2>
                                        AS DEVELOPER...
                                    </h2>
                                    <div className="logo_grp">
                                        {developerData.map(developer)}
                                    </div>
                                </div>
                                <div className="designer">
                                    <div className="logo_grp">
                                        {designerData.map(designer)}
                                    </div>
                                    <h2>
                                        AS DESIGNER...
                                    </h2>
                                </div>
                            </div>
                        </animated.div> : ""
                )
            }
        </div>
    );
}

export default Skill;